import {
  AllCommunityModule,
  ModuleRegistry,
  provideGlobalGridOptions,
} from 'ag-grid-community';
import { AG_GRID_PAGE_SIZE_OPTIONS } from './ag-grid-pagination.util';

/** App-wide AG Grid defaults (registered once from main.ts). */
export function configureAgGridGlobalDefaults(): void {
  ModuleRegistry.registerModules([AllCommunityModule]);
  provideGlobalGridOptions({
    theme: 'legacy',
    popupParent: document.body,
    paginationPageSizeSelector: [...AG_GRID_PAGE_SIZE_OPTIONS],
  });
}
